import type { PropsWithChildren } from 'react'

/**
 * Thin page wrapper. The Telegram back button is now managed centrally
 * by `TelegramBackButtonController` (mounted in `AppLayout`), so this
 * component no longer needs a `back` prop.
 */
export function Page({ children }: PropsWithChildren) {
	return <>{children}</>
}
